'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00247 from "./presto.-Agent-View$$anon$7.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dOpened$0024 from "./presto.-Agent-View$-Opened$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$6() {
  this.azM = null;
  this.azE = null;
  this.azF = false;
  this.azN = null;
  this.azO = false;
  this.azR = null;
  this.azK = null;
  this.azL = false;
  this.azG = null;
  this.azH = false;
  this.azI = null;
  this.azJ = false;
  this.azP = false;
  this.azQ = false;
  this.azM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.azR = "Opened";
}
export { $c_Lpresto_AgentView$$anon$6 as $c_Lpresto_AgentView$$anon$6 };
$p = $c_Lpresto_AgentView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$6;
/** @constructor */
function $h_Lpresto_AgentView$$anon$6() {
}
export { $h_Lpresto_AgentView$$anon$6 as $h_Lpresto_AgentView$$anon$6 };
$h_Lpresto_AgentView$$anon$6.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.azM;
});
$p.M = (function() {
  if ((!this.azF)) {
    this.azE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.azF = true;
  }
  return this.azE;
});
$p.O = (function() {
  if ((!this.azO)) {
    this.azN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.azO = true;
  }
  return this.azN;
});
$p.E = (function() {
  return this.azR;
});
$p.t = (function() {
  if ((!this.azL)) {
    this.azK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.azL = true;
  }
  return this.azK;
});
$p.N = (function() {
  if ((!this.azH)) {
    this.azG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.azH = true;
  }
  return this.azG;
});
$p.Q = (function() {
  if ((!this.azJ)) {
    this.azI = new $j_presto$002e$002dAgent$002dView$0024$0024anon$00247.$c_Lpresto_AgentView$$anon$7();
    this.azJ = true;
  }
  return this.azI;
});
$p.v = (function() {
  if ((!this.azQ)) {
    this.azP = false;
    this.azQ = true;
  }
  return this.azP;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee57) => ((p) => \u03b4scrutinee57))($j_presto$002e$002dAgent$002dView$0024$002dOpened$0024.$m_Lpresto_AgentView$Opened$())));
});
var $d_Lpresto_AgentView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$6, "presto.AgentView$$anon$6", ({
  E8: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$6 as $d_Lpresto_AgentView$$anon$6 };
//# sourceMappingURL=presto.-Agent-View$$anon$6.js.map
